import { useState, useEffect } from 'react';
import { has, get } from 'lodash';
import { ajaxExceptionMessage } from '@skunexus/utils';
import { helpers } from '@skunexus/custom-fields';

import * as API from '../api';

const useProduct = ({ errorNotification }) => {
    const [product, setProduct] = useState(null);
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState(null);

    const fetchProduct = async (id) => {
        setIsFetching(true);

        try {
            const result = await API.fetchProduct({ id });

            if (has(result, 'data.errors')) {
                throw new Error('Error occurs in graphql');
            }
            const product = result?.data?.data?.product?.details;
            setProduct({
                ...product,
                customValues: helpers.utils.mapCustomValuesArrayToObject(get(product, 'customValues', [])),
            });
        } catch (e) {
            setError(e);
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        if (error) {
            errorNotification(ajaxExceptionMessage(error));
        }
    }, [error]);

    return {
        product,
        isFetching,
        error,
        fetchProduct,
    };
};

export default useProduct;
